<template>
<div class="chapter">
<div class="inner_page">
<div id="con">
<h2 class="aboutAuthorHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry" id="dedi" style="margin-bottom:1em;">
<p class="contentsEntryName"><span href="#/ded#dedi" title="Link target outside of Sample">Dedication</span>
</p></div>
<div class="contentsEntry" id="int_01" style="margin-top:0em;">
<p class="contentsEntryName"><a href="#/int01#int01">Introduction</a>
</p></div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryName"><a href="#/ch01#ch01">It’s Not Daytona—You’re Not Jeff Gordon</a>
</p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryName"><a href="#/ch02#ch02">Take a Vacation, Not a Guilt-Trip</a>
</p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryName"><a href="#/ch03#ch03">Guest Room Grinches</a>
</p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryName"><span href="#/ch04#ch04" title="Link target outside of Sample">Dodge the Oddballs</span></p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryName"><span href="#/ch05#ch05" title="Link target outside of Sample">Do as Columbo Does</span></p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryName"><span href="#/ch06#ch06" title="Link target outside of Sample">Have Dessert, but Skip the Poison</span></p></div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryName"><span href="#/ch07#ch07" title="Link target outside of Sample">Handling Cruella the Salesclerk</span></p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryName"><span href="#/ch08#ch08" title="Link target outside of Sample">Be a Hum-Bug</span></p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryName"><span href="#/ch09#ch09" title="Link target outside of Sample">Take Back the Wheel</span></p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryName"><span href="#/ch10#ch10" title="Link target outside of Sample">Agree and Be Free</span></p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryName"><span href="#/ch11#ch11" title="Link target outside of Sample">Hades or Homecoming?</span></p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryName"><span href="#/ch12#ch12" title="Link target outside of Sample">Tune ’Em Out</span></p></div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryName"><span href="#/ch13#ch13" title="Link target outside of Sample">Picture the Perfect Encounter</span></p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryName"><span href="#/ch14#ch14" title="Link target outside of Sample">Go to Your Room!</span></p></div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryName"><span href="#/ch15#ch15" title="Link target outside of Sample">Don’t Dance</span></p></div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryName"><span href="#/ch16#ch16" title="Link target outside of Sample">Call a Lawyer</span></p></div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryName"><span href="#/ch17#ch17" title="Link target outside of Sample">Love the Players, If Not the Play</span></p></div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryName"><span href="#/ch18#ch18" title="Link target outside of Sample">Let Go, Let God</span></p></div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryName"><span href="#/ch19#ch19" title="Link target outside of Sample">Remember to Breathe</span></p></div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryName"><span href="#/ch20#ch20" title="Link target outside of Sample">Expect Less, Enjoy More</span></p></div>
<div class="contentsEntry" id="ch_21">
<p class="contentsEntryName"><span href="#/ch21#ch21" title="Link target outside of Sample">Get Mad, but Not <em class="italic">That</em> Mad</span></p></div>
<div class="contentsEntry" id="ch_22">
<p class="contentsEntryName"><span href="#/ch22#ch22" title="Link target outside of Sample">Be Mad About What You’re Mad About</span></p></div>
<div class="contentsEntry" id="ch_23">
<p class="contentsEntryName"><span href="#/ch23#ch23" title="Link target outside of Sample">Let ’Em Steam</span></p></div>
<a id="page05"></a>
<div class="contentsEntry" id="ch_24">
<p class="contentsEntryName"><span href="#/ch24#ch24" title="Link target outside of Sample">The Benefits of Selective Intolerance</span></p></div>
<div class="contentsEntry" id="ch_25">
<p class="contentsEntryName"><span href="#/ch25#ch25" title="Link target outside of Sample">Keeping Your Identity—And Your Wallet</span></p></div>
<div class="contentsEntry" id="ch_26">
<p class="contentsEntryName"><span href="#/ch26#ch26" title="Link target outside of Sample">Quit Being Your Mother</span></p></div>
<div class="contentsEntry" id="ch_27">
<p class="contentsEntryName"><span href="#/ch27#ch27" title="Link target outside of Sample">Give the Gift of a Second Chance</span></p></div>
<div class="contentsEntry" id="ch_28">
<p class="contentsEntryName"><span href="#/ch28#ch28" title="Link target outside of Sample">The Punk Band Next Door</span></p></div>
<div class="contentsEntry" id="ch_29">
<p class="contentsEntryName"><span href="#/ch29#ch29" title="Link target outside of Sample">Retail Therapy</span></p></div>
<div class="contentsEntry" id="ch_30">
<p class="contentsEntryName"><span href="#/ch30#ch30" title="Link target outside of Sample">Let Jerks Be Jerks</span></p></div>
<div class="contentsEntry" id="ch_31">
<p class="contentsEntryName"><span href="#/ch31#ch31" title="Link target outside of Sample">Professional Victims and Need Monsters</span></p></div>
<div class="contentsEntry" id="ch_32">
<p class="contentsEntryName"><span href="#/ch32#ch32" title="Link target outside of Sample">Turn Hissing Cats into Purring Kitties</span></p></div>
<div class="contentsEntry" id="ch_33">
<p class="contentsEntryName"><span href="#/ch33#ch33" title="Link target outside of Sample">Taking On Teams of Turkeys</span></p></div>
<div class="contentsEntry" id="ch_34">
<p class="contentsEntryName"><span href="#/ch34#ch34" title="Link target outside of Sample">If You Were Dr. Phil, You’d Be on TV</span></p></div>
<div class="contentsEntry" id="ch_35">
<p class="contentsEntryName"><span href="#/ch35#ch35" title="Link target outside of Sample">Open-Heart Policy</span></p></div>
<div class="contentsEntry" id="ch_36">
<p class="contentsEntryName"><span href="#/ch36#ch36" title="Link target outside of Sample">Watch and Learn from Mr. or Mrs. Ballistic</span></p></div>
<div class="contentsEntry" id="ch_37">
<p class="contentsEntryName"><span href="#/ch37#ch37" title="Link target outside of Sample">Hunt Hard for Something to Like</span></p></div>
<div class="contentsEntry" id="ch_38">
<p class="contentsEntryName"><span href="#/ch38#ch38" title="Link target outside of Sample">Scheduling Your First Intervention</span></p></div>
<div class="contentsEntry" id="ch_39">
<p class="contentsEntryName"><span href="#/ch39#ch39" title="Link target outside of Sample">Go Toe-to-Toe, and Heart-to-Heart</span></p></div>
<div class="contentsEntry" id="ch_40">
<p class="contentsEntryName"><span href="#/ch40#ch40" title="Link target outside of Sample">Size Up Your Opponent</span></p></div>
<div class="contentsEntry" id="ch_41">
<p class="contentsEntryName"><span href="#/ch41#ch41" title="Link target outside of Sample">Acceptance</span></p></div>
<div class="contentsEntry" id="ch_42">
<p class="contentsEntryName"><span href="#/ch42#ch42" title="Link target outside of Sample">Terrible Teens and Suggestions on How to Tame Them</span></p></div>
<div class="contentsEntry" id="ch_43">
<p class="contentsEntryName"><span href="#/ch43#ch43" title="Link target outside of Sample">When the Boss Ain’t So Boss</span></p></div>
<div class="contentsEntry" id="ch_44">
<p class="contentsEntryName"><span href="#/ch44#ch44" title="Link target outside of Sample">Spin That Turkey</span></p></div>
<div class="contentsEntry" id="ch_45">
<p class="contentsEntryName"><span href="#/ch45#ch45" title="Link target outside of Sample">Check Your Mood at the Door</span></p></div>
<div class="contentsEntry" id="ch_46">
<p class="contentsEntryName"><span href="#/ch46#ch46" title="Link target outside of Sample">How NOT to Ruin Relationships with E-mail</span></p></div>
<div class="contentsEntry" id="ch_47">
<p class="contentsEntryName"><span href="#/ch47#ch47" title="Link target outside of Sample">Enough About You, Let’s Talk About Me</span></p></div>
<div class="contentsEntry" id="ch_48">
<p class="contentsEntryName"><span href="#/ch48#ch48" title="Link target outside of Sample">Your Life Is Your Message</span></p></div>
<div class="contentsEntry" id="ch_49">
<p class="contentsEntryName"><span href="#/ch49#ch49" title="Link target outside of Sample">Red Light Means “Relax”</span></p></div>
<div class="contentsEntry" id="ch_50" style="margin-bottom:1em;">
<p class="contentsEntryName"><span href="#/ch50#ch50" title="Link target outside of Sample">Discovering Your Inner Turkey</span></p></div>
<div class="contentsEntry" id="ack_01" style="margin-top:0em;">
<p class="contentsEntryName"><span href="#/ack01#ack01" title="Link target outside of Sample">Acknowledgments</span></p></div>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName"><span href="#/ata01#ata01" title="Link target outside of Sample">About the Author</span></p></div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/cop01#cop01" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?32e6074a